import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthApiService } from '../../services/auth-api.service';
import { I18nService } from '../../services/i18n.service';
import { AuthCardComponent } from '../../ui/auth-card.component';

type ConfirmState = 'loading' | 'ok' | 'expired' | 'invalid' | 'unknown';

@Component({
  selector: 'auth-confirm-email',
  standalone: true,
  imports: [RouterLink, AuthCardComponent],
  template: `
    <auth-card [title]="i18n.t('confirm.heading')">
      @if (state() === 'loading') {
        <p class="au-card__sub">{{ i18n.t('common.loading') }}</p>
        <div class="au-spinner" aria-hidden="true"></div>
      }

      @if (state() === 'ok') {
        <p class="au-alert au-alert--ok">{{ i18n.t('confirm.subtitle') }}</p>
        <a class="au-button" [routerLink]="['/', langPath, 'login']">{{ i18n.t('confirm.go_login') }}</a>
      }

      @if (state() === 'expired') {
        <p class="au-alert au-alert--warn">{{ errorMessage() || 'Ссылка устарела. Запросите новое письмо.' }}</p>
        <a class="au-button" [routerLink]="['/', langPath, 'login']">{{ i18n.t('confirm.go_login') }}</a>
      }

      @if (state() === 'invalid' || state() === 'unknown') {
        <p class="au-alert au-alert--error">{{ errorMessage() || 'Не удалось подтвердить email.' }}</p>
        <a class="au-button" [routerLink]="['/', langPath, 'login']">{{ i18n.t('confirm.go_login') }}</a>
      }
    </auth-card>
  `,
})
export class ConfirmEmailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private api = inject(AuthApiService);
  protected i18n = inject(I18nService);

  readonly state = signal<ConfirmState>('loading');
  readonly errorMessage = signal<string>('');

  protected langPath: 'ru' | 'kz' = 'ru';

  async ngOnInit(): Promise<void> {
    const langParam = this.route.snapshot.paramMap.get('lang');
    this.langPath = langParam === 'kz' ? 'kz' : 'ru';
    await this.i18n.use(I18nService.normaliseFromUrl(langParam));

    const token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!token) {
      this.state.set('invalid');
      this.errorMessage.set(this.i18n.t('confirm.error') || 'Token не передан');
      return;
    }

    this.api.confirmEmail(token).subscribe({
      next: () => this.state.set('ok'),
      error: (err: HttpErrorResponse) => {
        const msg: string = err.error?.message ?? '';
        if (/expired/i.test(msg) || err.status === 410) {
          this.state.set('expired');
        } else if (err.status === 400 || err.status === 404) {
          this.state.set('invalid');
        } else {
          this.state.set('unknown');
        }
        this.errorMessage.set(msg);
      },
    });
  }
}
